import React, {useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {FaKey} from 'react-icons/fa';
import Post from './components/Post';
import AuthShell from './components/AuthShell';

const PostFree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = location.state?.id || query.get('id') || '';
  const [otp, setOtp] = useState('');
  const type = location.state?.type || query.get('type') || '';
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setLoading(true);
    try {
      const res = await Post.Otp({id, otp, type});
      if (!res.error) {
        if (type === 'forgot') {
          window.localStorage.setItem('user_bkp', JSON.stringify(res.data));
          navigate('/password');
        } else {
          alert(res.success);
          navigate('/');
        }
      } else {
        alert(res.errorMsg);
      }
    } catch (error) {
      alert('Unable to verify the code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={type === 'forgot' ? 'Reset Password' : 'Verify Mobile'}
      loading={loading}>
      <form
        className="auth-form"
        onSubmit={event => {
          event.preventDefault();
          verify();
        }}>
        <label className="auth-field">
          <FaKey className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            placeholder="Enter OTP"
            aria-label="Enter OTP"
            value={otp}
            onChange={event =>
              setOtp(event.target.value.replace(/[^0-9]/g, ''))
            }
          />
        </label>
        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Verifying...' : 'Next'}
        </button>
      </form>
      <div className="auth-footer">
        <span>Entered the wrong number?</span>
        <button
          className="auth-link"
          type="button"
          onClick={() => navigate('/')}>
          Back
        </button>
      </div>
    </AuthShell>
  );
};

export default PostFree;
